import type { ReactNode } from 'react';
import { deprecate } from '../../utils/deprecate';
import styles from './styles.module.css';

/** @deprecated use PageLoader from kitt-universal instead */
export function LargeLoader(): ReactNode {
  if (__DEV__) deprecate(LargeLoader.name, 'Use PageLoader from kitt-universal instead');
  return (
    <div className={styles.LargeLoader}>
      <svg width="60" height="60">
        <g className={styles.Base}>
          <circle cx="30" cy="30" r="27" fill="none" />
        </g>
        <g className={styles.Fill}>
          <circle cx="30" cy="30" r="27" fill="none" />
        </g>
      </svg>
    </div>
  );
}
